const en = {
    // Common
    'Close': 'Close',
    'From': 'From',
    'To': 'To',
    'Distance': 'Distance',
    'Estimated time': 'Estimated time',
    'Level': 'Level',
    'Search by name, category, building...': 'Search by name, category, building...',
    'Show legend': 'Show legend',
    'Ask with AI': 'Ask with AI',
    'Nothing was found': 'Nothing was found',
    'd': 'd',
    'h': 'h',
    'min': 'min',
    'Walk': 'Walk',
    'Bike': 'Bike',
    'Transit': 'Transit',
    'Drive': 'Drive',
    'Start wayfinding': 'Start wayfinding',
    // Location Details
    'Read full description': 'Read full description',
    // Locations list
    'Locations': 'Locations',
    'Directions not available': 'Directions not available',
    'Start directions': 'Start directions',
    // Route instructions
    'Previous': 'Previous',
    'Next': 'Next',
    'StepYofX': 'Step {{activeStep}} of {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'You have arrived',
    'Leave': 'Leave',
    'Park': 'Park',
    'at': 'at',
    'Building': 'Building',
    'Venue': 'Venue',
    'Take staircase to level': 'Take staircase to level',
    'Take the ladder to level': 'Take the ladder to level',
    'Take elevator to level': 'Take elevator to level',
    'Take escalator to level': 'Take escalator to level',
    'Take wheelchair lift to level': 'Take wheelchair lift to level',
    'Take wheelchair ramp to level': 'Take wheelchair ramp to level',
    'Exit': 'Exit',
    'Enter': 'Enter',
    'stops': 'stops',
    'and continue': 'and continue',
    'Continue straight ahead': 'Continue straight ahead',
    'Go left': 'Go left',
    'Go sharp left': 'Go sharp left',
    'Go slight left': 'Go slight left',
    'Go right': 'Go right',
    'Go sharp right': 'Go sharp right',
    'Go slight right': 'Go slight right',
    'Turn around': 'Turn around',
    // Wayfinding component
    'Switch': 'Switch',
    'Avoid stairs and escalators': 'Avoid stairs and escalators',
    'Include bus transportation': 'Include bus transportation',
    'No route found': 'No route found',
    'My position': 'My position',
    'Go!': 'Go!',
    'Directions': 'Directions',
    'Choose departure': 'Choose departure',
    'Choose destination': 'Choose destination',
    // Venue selector
    'Venues': 'Venues',
    'Select venue': 'Select venue',
    'Current': 'Current',
    // QR code dialog
    'Scan QR code': 'Scan QR code',
    'Scan the QR code to see the route on your phone': 'Scan the QR code to see the route on your phone',
    'Done': 'Done',
    // Directions
    'Cancel route': 'Cancel route',
    'Finish route': 'Finish route',
    // Share location link
    'Share': 'Share',
    'Copy link': 'Copy link',
    'QR Code': 'QR Code',
    // Opening Hours
    'Open': 'Open',
    'Closed': 'Closed',
    'Expand opening hours': 'Expand opening hours',
    'Collapse opening hours': 'Collapse opening hours',
    // View Selector
    'Go to view': 'Go to view',
    'Close view selector': 'Close view selector',
    // Language Selector
    'Select language': 'Select language',
    // Accessibility
    'Increase text size to 200%': 'Increase text size to 200%',
    'Decrease text size to 100%': 'Decrease text size to 100%',
    // Map Controls
    'Zoom in': 'Zoom in',
    'Zoom out': 'Zoom out',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Usage Consent',
    'Usage consent message': 'Ask with AI helps you find places and navigate this venue using Artificial Intelligence (AI). While we strive for accuracy, the AI may sometimes get things wrong. Please double-check important details before heading out.',
    'Usage consent accept': 'I understand',
    'Usage consent decline': 'Decline',
    'AI disclaimer': 'Ask with AI may make mistakes. Double-check important details before heading out.',
    // Location Consent
    'Location consent message': 'To provide personalized directions and help you discover what\'s nearby, Ask with AI would like to access your location. The chat will still work without knowing your location, but instead you\'ll need to specify a start point.',
    'Location consent accept': 'Allow',
    'Location consent decline': 'Decline',
};

export default en;
